import { Trans } from 'react-i18next';
import DryRoomSection2Image1Poster from '../../assets/dryroom_section2_image1.jpg';
import DryRoomSection2Image1 from '../../assets/dryroom_section2_image1.mp4';
import DryRoomSection2Image2 from '../../assets/dryroom_section2_image2.png';
import DryRoomSection2Image3 from '../../assets/dryroom_section2_image3.png';
import DryRoomSection2Image4 from '../../assets/dryroom_section2_image4.png';
import DryRoomSection2Image5 from '../../assets/dryroom_section2_image5.png';
import DryRoomSection2Image6 from '../../assets/dryroom_section2_image6.png';
import DryRoomSection2Image6Mobile from '../../assets/dryroom_section2_image6_mobile.png';
import { CenterLayout, HorizontalEqualLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, H4, H7, Text4 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useDeviceType } from '../../hooks/useDeviceType';

const CleanDryRoomSection2 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const { trackVideoPlay } = useAnalytics();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(193)}`} />
      <CenterLayout>
        <H4 style={{ textAlign: 'center' }}><Trans i18nKey='초정밀 환경을 만드는 기술, 비비테크의 클린 드라이룸 솔루션' /></H4>
      </CenterLayout>
      <BTBox height={isMobile ? 24 : `${pxToRem(55)}`} />
      <CenterLayout>
        <Body1 style={{ textAlign: 'center',
          ...isChina ? {wordBreak: 'break-word'} : {}
         }}><Trans i18nKey='비비테크는 단순한 설비 시공을 넘어, 생산 공간 전체를 설계합니다. 고효율 에너지 설비 설계와 Chemical-Free 기술을 바탕으로, 고객의 공정 흐름과 생산 안정성을 고려한 통합 환경 엔지니어링 솔루션을 제공합니다.' /></Body1>
      </CenterLayout>
      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />
      {isMobile ? (
        <video src={DryRoomSection2Image1}
          autoPlay
          muted
          loop
          playsInline
          poster={DryRoomSection2Image1Poster}
          onPlay={() => trackVideoPlay('클린룸드라이룸', 'clean_dryroom', 0)}
          style={{
            width: '100%', height: '400px', objectFit: 'cover',
            objectPosition: 'center',
          }} />
      ) : (
        <video
          src={DryRoomSection2Image1}
          autoPlay
          muted
          loop
          playsInline
          poster={DryRoomSection2Image1Poster}
          onPlay={() => trackVideoPlay('클린룸드라이룸', 'clean_dryroom', 0)}
          style={{
            width: '100%',
            height: isMobile ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
      )}

      <BTBox height={isMobile ? 60 : `${pxToRem(145)}`} />
      <HorizontalEqualLayout
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 0 : `${pxToRem(40)}`,
          width: '100%',
          alignItems: 'start'
        }}
      >
        <VerticalLayout style={{ flex: 0.4 }}>
          <BTBox height={isMobile ? 0 : `${pxToRem(57)}`} />
          <H7>
            <Trans i18nKey='클린룸 설계/시공'></Trans>
          </H7>
          <BTBox height={isMobile ? 0 : `${pxToRem(27)}`} />
          <Text4 style={{ color: '#00000080' }}>
            <Trans i18nKey='High Quality Construction 및 부속장비 설치' />
          </Text4>
          {isMobile && <BTBox height={16} />}
        </VerticalLayout>

        <VerticalLayout style={{ flex: 0.6 }}>
          <img src={DryRoomSection2Image2} style={{ width: '100%' }} />
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 40 : `${pxToRem(122)}`} />

      <VerticalLayout height={0.5} backgroundColor='black' style={{ opacity: 0.4 }}></VerticalLayout>

      <BTBox height={isMobile ? 20 : `${pxToRem(122)}`} />

      <HorizontalEqualLayout
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 0 : `${pxToRem(40)}`,
          width: '100%',
          alignItems: 'start'
        }}
      >
        <VerticalLayout style={{ flex: 0.4 }}>
          <BTBox height={isMobile ? 0 : `${pxToRem(57)}`} />
          <H7>
            <Trans i18nKey='드라이룸설계/시공' />
          </H7>
          <BTBox height={isMobile ? 0 : `${pxToRem(27)}`} />
          <Text4 style={{ color: '#00000080' }}>
            <Trans i18nKey='High Efficiency Engineering을 통한 설비 경제성 향상' />
          </Text4>
          {isMobile && <BTBox height={16} />}
        </VerticalLayout>

        <VerticalLayout style={{ flex: 0.6 }}>
          <img src={DryRoomSection2Image3} style={{ width: '100%' }} />
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 40 : `${pxToRem(122)}`} />

      <VerticalLayout height={0.5} backgroundColor='black' style={{ opacity: 0.4 }}></VerticalLayout>

      <BTBox height={isMobile ? 20 : `${pxToRem(122)}`} />

      <HorizontalEqualLayout
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 0 : `${pxToRem(40)}`,
          width: '100%',
          alignItems: 'start'
        }}
      >
        <VerticalLayout style={{ flex: 0.4 }}>
          <BTBox height={isMobile ? 0 : `${pxToRem(57)}`} />
          <H7>
            Clean Elevator Unit
          </H7>
          <BTBox height={isMobile ? 0 : `${pxToRem(27)}`} />
          <Text4 style={{ color: '#00000080' }}>
            <Trans i18nKey='층 간 청정도 차이에 따른 오염물 확산 방지' />
          </Text4>
          {isMobile && <BTBox height={16} />}
        </VerticalLayout>

        <VerticalLayout style={{ flex: 0.6 }}>
          <img src={DryRoomSection2Image4} style={{ width: '100%' }} />
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 40 : `${pxToRem(122)}`} />

      <VerticalLayout height={0.5} backgroundColor='black' style={{ opacity: 0.4 }}></VerticalLayout>

      <BTBox height={isMobile ? 20 : `${pxToRem(122)}`} />

      <HorizontalEqualLayout
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 0 : `${pxToRem(40)}`,
          width: '100%',
          alignItems: 'start'
        }}
      >
        <VerticalLayout style={{ flex: 0.4 }}>
          <BTBox height={isMobile ? 0 : `${pxToRem(57)}`} />
          <H7>
            RB/CRB System
          </H7>
          <BTBox height={isMobile ? 0 : `${pxToRem(27)}`} />
          <Text4 style={{ color: '#00000080' }}>
            <Trans i18nKey={"Chemical-Free 기반의 설비 오염 억제 기술 물을 사용하는 모든 설비에서 발생할 수 있는 오염을 효과적으로 억제"} />
          </Text4>
          {isMobile && <BTBox height={16} />}
        </VerticalLayout>

        <VerticalLayout style={{ flex: 0.6 }}>
          <img src={DryRoomSection2Image5} style={{ width: '100%' }} />
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={isMobile ? 40 : `${pxToRem(122)}`} />

      <VerticalLayout height={0.5} backgroundColor='black' style={{ opacity: 0.4 }}></VerticalLayout>

      <BTBox height={isMobile ? 40 : `${pxToRem(122)}`} />

      <img src={isMobile ? DryRoomSection2Image6Mobile : DryRoomSection2Image6} style={{ width: '100%' }} />
      <BTBox height={isMobile ? 40 : pxToRem(122)} />
      <CenterLayout>
        <H4>
          <Trans i18nKey='정밀한 환경 제어는 곧 품질 경쟁력입니다.'></Trans>
        </H4>
      </CenterLayout>
      <BTBox height={isMobile ? 24 : pxToRem(55)} />
      <CenterLayout>
        <Body1 style={{
          ...isMobile ? {fontSize: '13.9px'} : {}
        }}>
          <Trans i18nKey='비비테크는 에너지 소비를 최소화하면서 생산 품질을 높이고, 불량률 제로화를 위한 핵심 인프라를 구축합니다.' />
        </Body1>
      </CenterLayout>

      <BTBox height={isMobile ? 60 : pxToRem(276)} />
    </VerticalLayout>
  );
};

export default CleanDryRoomSection2;
